'use-client';
import * as React from 'react';
import WPhoto from '../../WPhotoBase';
import type { SkinWPhotoProps } from '../SkinWPhoto';
import type { BaseWPhotoSkinProps } from '../../../WPhoto.types';
import skinsStyles from './styles/DoubleBorderCirclePhoto.scss';
import BasicWPhotoSkin from './BasicWPhotoSkin';

const DoubleBorderCirclePhotoSkin: React.FC<
  Omit<BaseWPhotoSkinProps, 'skinsStyle'>
> = props => <BasicWPhotoSkin {...props} skinsStyle={skinsStyles} />;

const DoubleBorderCirclePhoto: React.FC<SkinWPhotoProps> = props => (
  <WPhoto {...props} skin={DoubleBorderCirclePhotoSkin} />
);

export default DoubleBorderCirclePhoto;
